import Typography from "@/components/foundation/typography"
import { Mission } from "@/store/missions/models"
import classNames from "classnames"
import _ from "lodash"
import React from "react"
import style from "./style.scss"

interface MissionItemBodyProps {
  mission: Mission
  title?: string
  description?: string
}

const MissionItemBody: React.SFC<Readonly<MissionItemBodyProps>> = (props) => {
  return (
    <div
      className={classNames(
        style.body,
        style[`body--${_.kebabCase(props.mission.getStatus())}`],
        {
          [style["body--tutorial"]]: props.mission.isTutorial
        }
      )}
    >
      {props.title && (
        <div className={style.header}>
          <Typography.H4 as="h2" className={style.title}>
            {props.title}
          </Typography.H4>
        </div>
      )}

      {props.description && (
        <div className={style.description}>
          <Typography.P1
            dangerouslySetInnerHTML={{ __html: props.description }}
          />
        </div>
      )}
    </div>
  )
}

export default MissionItemBody
